
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import CheckBox from '../../../../components/ZUILib/CheckBox';
import Warning from '../../../../components/Warning';
import ApplyCSS from '../../../../components/ApplyCSS';
import ContractPageForDownloadPDF from '../contractPageForDownloadPDF';
import commonUtil from '../../../../utils/commonUtil';
import pdfUtil from '../../../../utils/PDFUtil';
import DownloadPDFWithoutPreview from '../../../../components/DownloadPDFWithoutPreview';
import DownloadPDFWithoutPreviewContract from '../../../../components/DownloadPDFWithoutPreview/contract';
import DownloadContractForIphone from './../DownloadContractForIphone';
import { downloadContractIcon } from '../../page/SelectMesaType/components/svgIcons';


import { constAPIFailure, constAPISuccess, constDownload, constPrint } from '../../../../utils/clientConstant';

import * as createEventObject from '../../../createEvent/actions';
import EventWizard from './../EventWizard';

import { setPageFlag, loadContractPage } from './actions';
import { _fetchProfileEventsInfo } from '../../../Accounts/createAccount/actions';
import { loadEventDetails } from '../../../../components/EventDetails/actions';
import { createTag } from '../../../../utils/googleTagManagerUtils';

const pageName = 'contract';
const { saveUserData } = createEventObject;
const applicationRoutes = commonUtil.getApplicationRoutes();

const channel = commonUtil.getChannel();

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  contractPage: store.contractPage.data,
  eventDetails: store.eventDetail.data,
  globleObj: store.globleObject,
  eventCategoryType: store.eventcategory.data,
  createEventObject: store.createEventObject,
  printingDate: store.info && store.info.data && store.info.data.time,
  cartCountData: store.cartCountData.data,
  
}),
  { ...createEventObject, setPageFlag, loadContractPage, _fetchProfileEventsInfo, loadEventDetails })

class ContractPage extends Component {

  constructor(props) {
    super(props);
    this.userAllData = '';
    this.warningMessage = null;
    this.enableButton = true;
    this.state = { download: false, isChecked: false, isChecked2: false , isOpenPopUp:false};
    this.helpPopupContract = React.createRef();
  }

  UNSAFE_componentWillMount() {
    let eventType = '';
    let eventDate = '';
    let levelTwo = '';

    if (this.props.createEventObject && this.props.createEventObject.SelectTypeCelebration && this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration && this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name) {
      eventType = this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name;
    }
    levelTwo = eventType + '_' + 2;
    if (this.props.createEventObject && this.props.createEventObject[levelTwo] && this.props.createEventObject[levelTwo].data) {
      eventDate = this.props.createEventObject[levelTwo].data.eventDate;
    }
    const { loadContractPage } = this.props; // eslint-disable-line no-shadow
    loadContractPage(eventType, eventDate);
  }

  downloadToPDF = (param) => {
    const fileName = 'Contract';
    if (param && param === constDownload) {
      window.open(commonUtil.routeTo(applicationRoutes.downloadToPDF, [{ pageName }, { content: param }, { fileName }]), '_blank', 'scrollbars=yes,width=' + screen.width + ',height=' + screen.height);
    } else if (param && param === constPrint) {
      window.open(commonUtil.routeTo(applicationRoutes.downloadToPDF, [{ pageName }, { content: param }, { fileName }]), 'PRINT', '_blank', 'height=400,width=600');
    }
  }
  componentDidMount() {
    this.props.onReference(this);
    if (document && channel === 'WEB') {
      document.querySelector('.conntentBox').classList.add(this.props.animationClass);
    }
    commonUtil.goToTop();
    if (channel === 'wap') {
      document.addEventListener('click', this.handleClickOutside);
    }
  }

  getContractData = () => {
    const contractPage = this.props.contractPage;
    const contractData = (contractPage && contractPage.contractDetailsInfo && contractPage.contractDetailsInfo.contractdata) ? contractPage.contractDetailsInfo.contractdata : '';
    return contractData;
  }

  handlePDFDownload = () => {
    /* commented becuase in device iphone isn't working
    /* const isIOSDevice = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (isIOSDevice) {
      // window.open(applicationRoutes.downloadContractForIphone, '_blank');
      // this.setState({ download: true });
      // this.state.download = true;
      this.setDownlodState(true);
    } else { */
    const downloadableContent = (<DownloadPDFWithoutPreviewContract printingDate={this.props.printingDate} download fileName="contract"><ContractPageForDownloadPDF lables={this.props.lables} userAllData={this.userAllData} contractData={this.getContractData()} /></DownloadPDFWithoutPreviewContract>);
    pdfUtil.attachToDom(downloadableContent, 'contract');
    /* } */
  }

  handlePrint = () => {
    const printContent = (<DownloadPDFWithoutPreview printingDate={this.props.printingDate}><ContractPageForDownloadPDF contractData={this.getContractData()} lables={this.props.lables} userAllData={this.userAllData} /></DownloadPDFWithoutPreview>);
    pdfUtil.attachToDomForPrint(printContent, pageName, this.props.printingDate);
  }

  validate = (validationCallBack) => {
    if (document.getElementById('checkboxAceptTerm').checked) {
      if (this.enableButton) {
        this.enableButton = false;

        saveUserData(this.userAllData).then((response) => {
          if (response.body.status.status === constAPISuccess) {
            createTag({
              event: 'mesa_regalos',
              phase: 'Crear mesa de regalos',
              step: 'Termina registro',
              selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,
              seccion: 'Mesa de Regalos',
            });
            this.enableButton = false;
            this.props._fetchProfileEventsInfo().then(() => {
              const { clearEventData } = this.props;
              clearEventData();
              this.props.setPageFlag(true);
              this.props.loadEventDetails().then(() => {
                browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: response.body.data.event }));
              });
            });
          } else if (response.body.status.status === constAPIFailure) {
            this.enableButton = true;
            this.warning.setMessage(response.body.status.errorMessage);
            validationCallBack(false);
            return false;
          }
          this.enableButton = false;
          validationCallBack(false);
          return false;
        }).catch((error) => {
          this.enableButton = true;
          if (error && error?.body && error?.body?.detail) { 
            this.warning.setMessage(error.body?.detail);
            //this.warning.setMessage(commonUtil.getLabel(this.props.lables.createEventStep4, "createEventStep4."+error?.body?.detail)); 
          } else {
            this.warning.setMessage(error?.body?.errorMessage);
          }
        }, false);
      }
      return true;
    }

    const warningMessage = commonUtil.getLabel(this.props.lables.createEventStep4, 'createEventStep4.acceptCheckBox.warning.message');
    this.warning.setMessage(warningMessage);
    createTag({
      event: 'alerta',
      phase: 'Crear mesa de regalos',
      step: 'Terminar registro',
      mensaje: warningMessage,
      mensaje_servicio: warningMessage,
      seccion: 'Mesa de Regalos',
      tipo: 'pop-up',
    });

    return false;
  }

  setDownlodState = (dstate) => {
    this.setState({
      download: dstate,
    });
  }

  contractChk = (opt) => {
    if(opt.checked){
      this.setState({
        isChecked: true,
      });
    } else {
      this.setState({
        isChecked: false,
      });
    }
  }

  contractChk2 = (opt) => {    
    if(opt.checked){
      this.setState({
        isChecked2: true,
      });
    } else {
      this.setState({
        isChecked2: false,
      });
    }
  }

  componentWillUnmount() {
    if (channel === 'wap') {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  handlePopUpCoOwner = (e) => {
    if (channel === 'wap') {
      e.stopPropagation();
      e.preventDefault();
       this.setState( prevState => ({isOpenPopUp: !prevState.isOpenPopUp}))
    }
  }

  handleClickOutside = (event) => {
    if (channel === 'wap') {
      if (this.helpPopupContract.current && !this.helpPopupContract.current.contains(event.target) && this.state.isOpenPopUp) {
        this.setState({ isOpenPopUp: false });
      }
    }
  }

  render() {
    const { lables, contractPage, createEventObject, cartCountData } = this.props; // eslint-disable-line no-shadow
    let isxvanos = false;
    //createEventObject?.SelectTypeCelebration?.selectEventType
     const geteventtype = createEventObject?.SelectTypeCelebration?.selectEventType;
           if(geteventtype.lastIndexOf("XV a") !== -1)
             {
               isxvanos = true;
           }
    //console.log('createEventObject====', createEventObject?.SelectTypeCelebration?.selectEventType);
    if (createEventObject && createEventObject.SelectTypeCelebration) {
      this.currentEvent = createEventObject.SelectTypeCelebration.selectedEventConfiguration.name;
      this.eventDetail = this.props.eventCategoryType.eventConfigurations.filter(item => item.name === this.currentEvent)[0];
      this.currentEventCategory = '';
      if (createEventObject.SelectMesaType && createEventObject.SelectMesaType.trim().length > 0) {
        this.currentEventCategory = createEventObject.SelectMesaType;
      } else {
        this.currentEventCategory = this.eventDetail.eventCategory;
      }
      const levelOne = this.currentEvent + '_' + (this.props.currentStep - 2);
      const levelTwo = this.currentEvent + '_' + (this.props.currentStep - 1);
      const levelThree = this.currentEvent + '_' + (this.props.currentStep - 0);
      const profileId = createEventObject[levelOne] ? createEventObject[levelOne]?.data?.[0]?.profileId :"";
      if (createEventObject && createEventObject[levelThree]) {
        const giftRegistryCelebData = createEventObject[levelOne] ? createEventObject[levelOne].data : null;
        if(giftRegistryCelebData[0]) {
            let socialInfo = commonUtil.getSocialMediaInfo(cartCountData?.socialMediaInfo ? cartCountData?.socialMediaInfo: {});
            giftRegistryCelebData[0].socialMediaId = socialInfo.id;
            giftRegistryCelebData[0].socialMediaName = socialInfo.name;
            if(createEventObject && createEventObject.celebrityTitle && (createEventObject.celebrityTitle === 'Yo soy el festejado' || createEventObject.celebrityTitle === 'Yo estoy estrenando')){
              giftRegistryCelebData[0].celebrity = "true";
            }
        }

        if (giftRegistryCelebData[1]) {
         
          //giftRegistryCelebData[1].profileId = createEventObject && createEventObject.coOwnerProfileId && createEventObject.coOwnerProfileId.profileId ? createEventObject.coOwnerProfileId.profileId : '';
          if(giftRegistryCelebData[1]?.email && giftRegistryCelebData[1]?.phone)
          {
            giftRegistryCelebData[1].hasPermission = true;
          } else {
            giftRegistryCelebData[1].hasPermission = false;
          }
        }
        const createEventData = createEventObject[levelTwo].data;
        const giftRegistryAddressData = [];
        
        const giftRegistryAddress = createEventObject[levelThree].data;
        let codeData = {};
        giftRegistryAddress.map((addresses) => {
          codeData = {};
          if (addresses.address && addresses.address.phoneNumber) {
            const index = addresses.address.phoneNumber.indexOf('-');
            codeData.particularPhoneCode = addresses.address.phoneNumber.substr(0, index);
            codeData.phoneNumber = addresses.address.phoneNumber.substr(index + 1);
          }
          if (addresses.address && addresses.address.businessPhoneNumber) {
            const index = addresses.address.businessPhoneNumber.indexOf('-');
            codeData.businessPhoneCode = addresses.address.businessPhoneNumber.substr(0, index);
            codeData.businessPhoneNumber = addresses.address.businessPhoneNumber.substr(index + 1);
          }
          const a = {
            nickname: addresses.address.nickName,
            ecommAddressId: addresses.address.addressId,
            firstName: addresses.address.firstName,
            middleName: addresses.address.middleName,
            maternalName: addresses.address.maternalName,
            lastName: addresses.address.lastName,
            country: addresses.address.country,
            city: addresses.address.city,
            stateId: addresses.address.stateId,
            state: addresses.address.state,
            delegationMunicipality: addresses.address.delegationMunicipality,
            delegationMunicipalityId: addresses.address.delegationMunicipalityId,
            building: addresses.address.building,
            postalCode: addresses.address.postalCode,
            neighbourhood: addresses.address.neighbourhood,
            neighbourhoodId: addresses.address.neighbourhoodId,
            address1: addresses.address.address1,
            address2: addresses.address.address2,
            Address3: addresses.address.Address3,
            exteriorNumber: addresses.address.exteriorNumber,
            interiorNumber: addresses.address.interiorNumber ? addresses.address.interiorNumber : '',
            particularPhoneCode: codeData.particularPhoneCode,
            phoneNumber: codeData.phoneNumber,
            businessPhoneCode: codeData.businessPhoneCode ? codeData.businessPhoneCode : '',
            businessPhoneNumber: codeData.businessPhoneNumber ? codeData.businessPhoneNumber : '',
            cellular: addresses.address.cellular ? addresses.address.cellular : '',
            otherColony: addresses.address.neighbourhood, // As per colony is nothing but neighbourhood   if you are not selecting otherColony yes that is for othercolony
            celebrityName: addresses.priority.value || addresses.address.celebrityName || '',
          };
          giftRegistryAddressData.push(a);
          return undefined;
        });
        const contractData = (contractPage.contractDetailsInfo && contractPage.contractDetailsInfo.contractdata) ? contractPage.contractDetailsInfo.contractdata : '';
      
        this.userAllData = {
          eventType: this.currentEvent,
          eventCategory: this.currentEventCategory,
          preferredStoreId: createEventData.store,
          eventDate: createEventData.eventDate,
          eventName: createEventData.eventName,
          profileId:profileId,
          imageURL: createEventData.imageURL,
          imageBgURL: createEventData.imageURL2,
          templateId: createEventData.templateId,
          isEmployee: 'false',
          celebrityInfo: giftRegistryCelebData,
          addressesInfo: giftRegistryAddressData,
          contractStaticData:contractData
          
        };

        
      }
    }
    if (contractPage) {
      const contractData = (contractPage.contractDetailsInfo && contractPage.contractDetailsInfo.contractdata) ? contractPage.contractDetailsInfo.contractdata : '';
      return (
        <div>
          <ApplyCSS pageName={pageName} />
          {channel === 'wap' ?
            <div className={'innerWrap'}>
              <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
              <div className="row">
                <div className="col-md-8 col-md-offset-2 col-xs-12 col-xs-offset-0 scrollable-content-contract-page" id="contract">
                  {/* <h2 className="titleMesa">Mesa de regalos</h2>
                  <h1 className="titleSection m-b-30">Contrato</h1> */}
                  <p className="subtitleModule">{commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.contract.message')}</p>
                  <div className="downloadLinkDiv">
                    <a id="downloadLink" rel="noopener noreferrer" target="_blank">
                       <span className='download-icon-glc multi-download-svg-icon'
                              dangerouslySetInnerHTML={{ __html: downloadContractIcon }} onClick={() => this.handlePDFDownload()}>
                        </span>
                      {/* <img src={commonUtil.getAssetURL() + '/images/file_download_contract.svg'} alt="file_download" className="download-icon-glc" /> */}
                      </a>
                  </div>
                  <div className="pdfContent">
                    <p className="pdfContentptag" dangerouslySetInnerHTML={{ __html: contractData }} />
                  </div>
                  <div className="row">
                    <div className="col-xs-12 termsConditions contractConditions">
                      <CheckBox id="checkboxAceptTerm" getSelectedValue={this.contractChk} displayName={commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.acceptcontract.label')} />
                    </div>
                    {
                      isxvanos && (
                        <div className="col-xs-12 xvnostermsConditions wapxvnostermsConditions">
                          <CheckBox
                            id="checkboxAceptTermSecond"
                            getSelectedValue={this.contractChk2}
                            displayName={'Yo, o uno de los administradores cumple con la mayoría de edad'}
                          />
                          <div className="iconHelp inLine iconHelp-pl iconHelpWrapper">
                            <img src={commonUtil.getAssetURL() + '/images/help.svg'} alt="icon_help" className="icon_help" onClick={(e) => { this.handlePopUpCoOwner(e); }} />
                            <div className="tooltip-backdrop" />
                            <div id="helpPopupContract" ref={this.helpPopupContract} className="popover bottom helpIconCssEmail helpIconEventCss" style={{display : this.state.isOpenPopUp ? 'block' : 'none'}} >
                              <div className="arrow" />
                              <div className="popover-content">
                                {"Para acceder a los estados de cuenta y realizar retiros de la mesa de regalos, necesitamos confirmar que al menos una persona administradora sea mayor de edad."}
                              </div>
                            </div>
                          </div> 
                        </div>
                      )
                    }
                  </div>

                  <row>
                    <div className="buttonBlock" id="contractPageEventWizard">
                      <EventWizard prev={this.props.eventWizardAttributes.prevAttr} next={this.props.eventWizardAttributes.nextAttr} submit={this.props.eventWizardAttributes.submitAttr} currentStep={this.props.currentStep} totalStep={this.props.totalStepsForEvent} isDisabled={isxvanos ? !(this.state.isChecked && this.state.isChecked2) : !this.state.isChecked} />
                    </div>
                  </row>
                </div>
              </div>
            </div>
            :
            <div className="conntentBox">
              <div className="container">
                <div className="row innerMain">
                  <div className="col-md-10 col-md-offset-1 col-sm-12">
                    <div className="innerWrap contractWrapper">
                      <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
                      <div className=" visible-xs col-sm-3 buttonsPdf">
                        {/* <span className="icon-imprimir hover-icon" onClick={() => this.handlePrint()} /> */}
                        <a id="downloadLink"><span className="icon-descarga hover-icon lpColor" onClick={() => this.handlePDFDownload()} /></a>
                      </div>
                      <h1 className="titleSection text-center m-b-30">{commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.contract.title')}</h1>
                      <p className="subtitleModule text-center">{commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.contract.message')}</p>
                      <div className="pdfContent">
                        {/* <p>Contrato para la mesa de regalos de Liverpool</p> */}
                        <p className="pdfContentptag" dangerouslySetInnerHTML={{ __html: contractData }} />
                      </div>
                      <div className="row">
                        <div className="col-sm-9  termsConditions">
                          <CheckBox id="checkboxAceptTerm" getSelectedValue={this.contractChk} displayName={commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.acceptcontract.label')} />
                        </div>
                        {
                          isxvanos && (
                            <div className="col-sm-9  xvnostermsConditions">
                              <CheckBox
                                id="checkboxAceptTermSecond"
                                getSelectedValue={this.contractChk2}
                                displayName={'Yo, o uno de los administradores cumple con la mayoría de edad'}
                              />
                            </div>
                         
                        )}
                        <div className=" hidden-xs col-sm-3 buttonsPdf">
                          {/* <span className="icon-imprimir hover-icon" onClick={() => this.handlePrint()} /> */}
                          <a id="downloadLink">
                               <span className='download-icon-glc a multi-download-svg-icon'
                                     dangerouslySetInnerHTML={{ __html: downloadContractIcon }} onClick={() => this.handlePDFDownload()} >
                               </span>
                              {/* <img src={commonUtil.getAssetURL() + '/images/file_download_contract.svg'} alt="file_download" className="download-icon-glc a" onClick={() => this.handlePDFDownload()} /> */}
                            </a>
                        </div>
                      </div>
                      
                      <div className="row" id="contractPageEventWizard">
                        <EventWizard prev={this.props.eventWizardAttributes.prevAttr} next={this.props.eventWizardAttributes.nextAttr} submit={this.props.eventWizardAttributes.submitAttr} currentStep={this.props.currentStep} totalStep={this.props.totalStepsForEvent} isDisabled={isxvanos ? !(this.state.isChecked && this.state.isChecked2) : !this.state.isChecked} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          {/* <div style={{ display: 'none' }}>
            <ContractPageForDownloadPDF contractData={contractData} lables={lables} userAllData={this.userAllData} />
          </div> */}
          {this.state.download ?
            <DownloadContractForIphone printingDate={this.props.printingDate} lables={this.props.lables} contractPage={this.props.contractPage} onCompletion={this.setDownlodState} /> : null
          }
        </div>
      );
    } return null;
  }
}

export default ContractPage;
